import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { NextAction } from '../models/nextAction';

export const getNextAction = (trainingType: string, trainingId: string): Promise<NextAction> => {
  return cacheableRequest(
    `/v1/training-next-action?${trainingType === 'Pathway' ? 'pathwayId' : 'courseId'}=${trainingId}`
  ).then((response: AxiosResponse) => response.data);
};
